import { render } from "./Deactivated.vue?vue&type=template&id=1445d2a1&scoped=true"
import script from "./Deactivated.vue?vue&type=script&lang=js"
export * from "./Deactivated.vue?vue&type=script&lang=js"

import "./custom-deactivate.scss?vue&type=style&index=0&id=1445d2a1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1445d2a1"]])

export default __exports__